import { render, staticRenderFns } from "./BOL.vue?vue&type=template&id=7a7f2464&scoped=true&"
import script from "./BOL.vue?vue&type=script&lang=js&"
export * from "./BOL.vue?vue&type=script&lang=js&"
import style0 from "./BOL.vue?vue&type=style&index=0&id=7a7f2464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7f2464",
  null
  
)

export default component.exports